<div class="mobile-menu-dialog__header">
	<img draggable="false" src="assets/images/wordmark-white.png" />
	<button
		class="secondary"
		tuiIconButton
		appearance="ghost"
		size="m"
		(click)="onDismiss()"
	>
		<tui-icon size="l" icon="@tui.x" />
	</button>
</div>

<header tuiHeader class="mobile-menu-dialog__content-profile">
	<ctx-avatar
		size="l"
		routerLink="profile"
		(click)="onDismiss()"
		[user]="authService.user ?? authService.authUser"
	/>
	<div class="mobile-menu-dialog__content-profile-info">
		<p class="color-primary margin-v-0 font-size-xlarge font-bold">
			{{ authService.user | userName }}
		</p>
		<p class="color-tertiary margin-v-0 font-size-small">
			{{ authService.organization()!.name }}
		</p>
	</div>
</header>

<section tuiContent>
	<div class="max-w-xs">
		@for (item of context.data.menuItems; track item.key) {
			@if (
				(item.location === 'side' ||
					item.location === 'all' ||
					item.location === 'mobile') &&
				(!item.requiredRole || (item.requiredRole | roleAccess))
			) {
				@if (item.handler) {
					<button
						tuiLink
						size="l"
						class="menu-button"
						[iconStart]="item.icon"
						(click)="onClick(item)"
					>
						{{ 'navigation.' + item.key | transloco }}
					</button>
				} @else {
					<a
						tuiLink
						size="l"
						class="menu-button"
						[iconStart]="item.icon"
						[routerLink]="[item.route]"
						routerLinkActive="active"
						(click)="onDismiss(item)"
					>
						{{ 'navigation.' + item.key | transloco }}
					</a>
				}
			}
		}

		<div class="ctx-divider"></div>

		<p class="font-size-small color-tertiary opacity-50 py-2 px-4">
			{{ 'app.version' | transloco: { version: version } }}
		</p>
	</div>
</section>
